import * as React from 'react'
import * as s from './InfoSidebar.scss'

export interface IContactSidebarProps {
  children: any
}

export const InfoSidebar = ({ children }: IContactSidebarProps) => {
  return <div className={s.outer}>{children}</div>
}



// WEBPACK FOOTER //
// src/components/InfoSidebar/InfoSidebar.tsx